import { CommonModule } from '@angular/common';
import { DialogService } from './services/dialog.service';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { RouterModule } from '@angular/router';
import { SelectComponent } from './components/select/select.component';
import { SideFilterComponent } from './components/side-filter/side-filter.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
// import {SwiperModule} from 'swiper/angular';
import {
	ConfirmationModal,
} from './components/dialog/dialog.component';
import { ItemTileComponent } from "../home/components/store-detail/item-tile/item-tile.component";
import { AsSliderComponent } from "./components/as-slider/as-slider.component";
import { RatingBoxComponent } from "./components/rating-box/rating-box.component";
import { InputComponent } from "./components/input/input.component";
import { AlertPopupComponent } from "./components/alert-popup/alert-popup.component";
import { LightCheckboxComponent } from "./components/light-checkbox/light-checkbox.component";
import { RadioComponent } from "./components/radio-button/radio-button.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";
import { TextAreaComponent } from "./components/text-area/text-area.component";
import { ItemListComponent } from '../home/components/filtered-items/item-list/item-list.component';

function components() {
	return [
		SpinnerComponent,
		SelectComponent,
		SideFilterComponent,
		ConfirmationModal,
		ItemTileComponent,
		ItemListComponent,
		AsSliderComponent,
		RatingBoxComponent,
		InputComponent,
		AlertPopupComponent,
		LightCheckboxComponent,
		RadioComponent,
		PaginationComponent,
		DatePickerComponent,
		TextAreaComponent,
	];
}

@NgModule({
	declarations: [...components()],
	imports: [
		CommonModule,
		RouterModule,
		MaterialModule,
		// SwiperModule,
		NgxSliderModule,
		FormsModule,
	],
	exports: [
		MaterialModule,
		...components(),
		RouterModule,
		// SwiperModule,
		NgxSliderModule,
		FormsModule,
	],
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule,
			providers: [DialogService],
		};
	}
}
